export type PriceParts = {
  /** everything before the cents, e.g. "$1,234" or "1.047" */
  head: string;
  /** the locale's decimal separator, kept so the cents read as cents */
  separator: string;
  /** the cents digits, e.g. "99" */
  cents: string;
  /** anything after the cents — the "€" on euro stores */
  tail: string;
};

export const splitPriceForSuperscript = (
  price: string,
  separator: string,
): PriceParts | null => {
  const index = price.lastIndexOf(separator);

  if (index === -1) {
    return null;
  }

  const fraction = price.slice(index + separator.length);
  const [cents] = fraction.match(/^\d+/) ?? [];

  if (!cents) {
    return null;
  }

  return {
    head: price.slice(0, index),
    separator,
    cents,
    tail: fraction.slice(cents.length),
  };
};

export const buildSuperscript = ({
  separator,
  cents,
  tail,
}: PriceParts): string => `${separator}${cents}${tail.trimStart()}`;
